module.exports = __webpack_public_path__ + "img/callbacks_title.c41d932d.svg";